import { render, staticRenderFns } from "./detailIssue.vue?vue&type=template&id=0ee34986&"
import script from "./detailIssue.vue?vue&type=script&lang=js&"
export * from "./detailIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee34986')) {
      api.createRecord('0ee34986', component.options)
    } else {
      api.reload('0ee34986', component.options)
    }
    module.hot.accept("./detailIssue.vue?vue&type=template&id=0ee34986&", function () {
      api.rerender('0ee34986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/model/agreeDetail/detailIssue.vue"
export default component.exports